export default "__VITE_ASSET__C9n$mkAA__"